<template>
  <div>
    <shipblu-card :cardLoading="productLoading" class="p-5">
      <div class="flex mb-3 justify-between">
        <h3>{{ $t('Products') }} {{ $store.state.AppActiveUser.userRole === 'fc-operations-supervisor' ? '(' + orderProducts.reduce((acc, product) => acc + (Number(product.quantity) || 0), 0) + ')' : '' }}</h3>
        <vs-button v-if="$store.state.AppActiveUser.userRole === 'merchant' && orderData.status === 'created'" @click="addNewProduct('Add New Product')" color="primary" class="py-2 px-3">{{ $t('Add more products') }}</vs-button>
      </div>
      <shipblu-table
        :sst="true"
        multiple
        v-model="selected"
        :hideHeader="true"
        :data="orderProducts"
      >
        <template slot="thead">
          <shipblu-th>{{$t('SKU')}}</shipblu-th>
          <shipblu-th>{{$t('Product Name')}}</shipblu-th>
          <shipblu-th>{{$t('Description')}}</shipblu-th>
          <shipblu-th>{{$t('Quantity')}}</shipblu-th>
          <shipblu-th v-if="$store.state.AppActiveUser.userRole === 'merchant' && $route.params.type === 'outbound'">{{$t('Current Inventory')}}</shipblu-th>
          <shipblu-th>{{$t('Size')}}</shipblu-th>
          <shipblu-th>{{$t('Color')}}</shipblu-th>
          <shipblu-th>{{$t('Flags')}}</shipblu-th>
          <shipblu-th v-if="$store.state.AppActiveUser.userRole === 'merchant'">
            <feather-icon icon="ChevronDownIcon" svgClasses="h-5 w-5"/>
          </shipblu-th>
        </template>

        <template slot-scope="{ data }">
          <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <shipblu-td class="order-9" :data="data[indextr].sku">
              <div class="flex sm:static absolute top-3 gap-2 items-start justify-start transform-50" v-on:click.stop>
                {{ data[indextr].product ? data[indextr].product.sku : '' }}
              </div>
            </shipblu-td>

            <shipblu-td class="sm:hidden block col-span-2 p-0 order-3">
              <!-- line -->
              <p style="background-color: #DCDCDC;height: 1px;"></p>
            </shipblu-td> 

            <shipblu-td class="order-3" :data="data[indextr].productName">
              <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Product Name')}}</p>
              {{ data[indextr].product ? data[indextr].product.name : '' }}
            </shipblu-td>

            <shipblu-td class="order-4" :data="data[indextr].description">
              <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Description')}}</p>
              {{ data[indextr].product ? data[indextr].product.description : '' }}
            </shipblu-td>

            <shipblu-td class="order-5" :data="data[indextr].description">
              <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Quantity')}}</p>
              {{ data[indextr].product ? data[indextr].quantity : '' }}
            </shipblu-td>

            <shipblu-td class="order-6" :data="data[indextr].currentInventoryLevel" v-if="$store.state.AppActiveUser.userRole === 'merchant' && $route.params.type === 'outbound'">
              <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Current Inventory')}}</p>
              {{ data[indextr].product?.locations?.reduce((sum, { stored_quantity }) => sum + stored_quantity, 0) }}
            </shipblu-td>

            <shipblu-td class="order-7" :data="data[indextr].size">
              <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Size')}}</p>
              {{ data[indextr].product ? data[indextr].product.size : '' }}
            </shipblu-td>

            <shipblu-td class="order-8" :data="data[indextr].color">
              <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Color')}}</p>
              <div class="color-container h-6 w-3/4">
                <div class="w-full h-full" :style="`background-color:${ data[indextr].product ? data[indextr].product.color : 'black'}`"></div>
              </div>
            </shipblu-td>

            <shipblu-td class="order-9" :data="data[indextr].flags">
              <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Flags')}}</p>
              <p v-for="(item, index) in data[indextr].flags" :key="index">
                {{ item.name }}
              </p>
            </shipblu-td>

            <shipblu-td class="order-2" v-if="$store.state.AppActiveUser.userRole === 'merchant'">
              <p class="md:text-center text-right" @click="addNewProduct('Edit Product', data[indextr])" 
                :disabled="!orderInfoEditable" :class="orderData.status === 'created' ? 'text-primary' : 'disabled'">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="h-6 w-6"
                  class="mr-2"
                />
              </p>
              <p class="md:text-center text-right" v-if="orderProducts.length > 1" @click="$emit('deleteProduct', data[indextr])" 
                :disabled="!orderInfoEditable" :class="orderData.status === 'created' ? 'text-danger' : 'disabled'">
                <feather-icon
                  icon="Trash2Icon"
                  svgClasses="h-6 w-6"
                />
              </p>
            </shipblu-td>
          </shipblu-tr>
        </template>
      </shipblu-table>
    </shipblu-card>

    <add-order :orderProducts="orderProducts" :orderProduct="orderProduct" :type="type" :orderModal="orderModal" :order="order" @orderModal="orderModal = $event" @loadOrder="loadOrder"></add-order>
  </div>
</template>

<script>
import ShipbluCard from '@/layouts/components/ShipbluCard.vue'
import ShipbluTable from '@/layouts/components/NewShipBluTable.vue'
import ShipbluTr from '@/layouts/components/ShipBluTr.vue'
import ShipbluTh from '@/layouts/components/ShipBluTh.vue'
import ShipbluTd from '@/layouts/components/ShipBluTd.vue'
import AddOrder from '../../components/AddOrder.vue'

export default {
  props: ['selected', 'orderProducts', 'orderData', 'orderInfoEditable', 'productLoading'],
  data () {
    return {
      type: 'Add New Product',
      orderProduct: {},
      order: {},
      orderModal: false
    }
  },
  methods: {
    addNewProduct (type, data) {
      this.type = type
      if (type === 'Add New Product') {
        this.stockProduct = Object.assign({}, {})
      } else {
        this.orderProduct = data
        this.orderProduct.product.optionalLabel = `SKU: ${data.product.sku} . ${data.product.current_inventory_level} available`
      }
      this.orderModal = true
    },
    loadOrder () {
      this.$emit('loadOrder')
    }
  },
  components: {
    ShipbluCard,
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    AddOrder
  }
}
</script>